import React, { Fragment, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';

import './../Resources/css/block_aboutUs.css'

import Block from '../../../Controls/Scafolding/Block';
import { TextHeader, TextTitle, TextBock } from '../../../Controls/Digital/TextHeaders';

import img_iconCampos from '../Resources/Images/AboutUs/camposLogo.webp';
import img_1 from '../Resources/Images/AboutUs/coffeeCup.jpg';
import img_2 from '../Resources/Images/AboutUs/product_sample_15.jpg';
import img_3 from '../Resources/Images/AboutUs/product_sample_14.jpg';
import { AnimatedImage } from '../../../Controls/Digital/AnimatedImage';

const AboutUs = (props) => {

    const [blockName, setBlockName] = useState("");

    return (

        <Block name="aboutUs" isAlt={true}>

            <Row className="">
                <Col lg="12">
                    <Container>
                        <Row>
                            <Col lg="12" className="d-none d-sm-block top-message top-message-lg">
                                Gwynneville Bakery & Co.
                            </Col>

                            <Col lg="12" className="d-none d-sm-block low-message low-message-lg">
                                handcrafted bread, pastries & cakes
                            </Col>

                            <Col lg="12" className="d-block d-sm-none d-flex top-message top-message-xs">
                                Gwynneville Bakery & Co.
                            </Col>

                            <Col lg="12" className="d-block d-sm-none low-message low-message-xs">
                                handcrafted bread, pastries & cakes
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>

            <TextHeader text={
                <Fragment>
                    proudly serving from 2025
                </Fragment>
            } />

            <Row className="logoRow">
                <Col lg="12" className="text-center">
                    <img src={img_iconCampos} className="img-fluid" />
                </Col>
            </Row>

            <Row>
                <Col lg="4" className="about-photo-frame img-text-container">
                    <AnimatedImage image={img_1} />
                </Col>
                <Col lg="4" className="about-photo-frame img-text-container">
                    <AnimatedImage image={img_2} />
                </Col>
                <Col lg="4" className="about-photo-frame img-text-container">
                    <AnimatedImage image={img_3} />
                </Col>

                <Col lg="12" className="about-photo-frame about-text">
                    <Container>
                        <TextTitle text={
                            <Fragment>
                                Welcome to The Gwynneville Bakery
                            </Fragment>
                        } />
                        <TextBock text={
                            <Fragment>
                                At The Gwynneville Bakery, great food and genuine hospitality are at the heart of everything we do. We’re passionate about using the freshest ingredients to create satisfying lunches, dinners, and treats that keep our customers coming back.
                            </Fragment>
                        } />

                        <TextTitle text={
                            <Fragment>
                                Our Story
                            </Fragment>
                        } />
                        <TextBock text={
                            <Fragment>
                                Originally opened in 1990 as The Gwynneville Gourmet Bakery, we began as a cozy spot serving the local community. In 2013, we expanded into a larger, more spacious home, warm and welcoming inspired on Parisian pâtisseries; perfect for enjoying coffee, cakes, or a hearty lunch.
                            </Fragment>
                        } />

                        <TextTitle text={
                            <Fragment>
                                What We Serve
                            </Fragment>
                        } />
                        <TextBock text={
                            <Fragment>
                                From award-winning coffee and house-made pastries to nourishing lunches, we pride ourselves on flavour and freshness. Our quiches and vegan pies are local favorites, complemented by our sandwich menu and salad bar, all prepared fresh daily.
                            </Fragment>
                        } />

                        <TextTitle text={
                            <Fragment>
                                Our Selection includes
                            </Fragment>
                        } />

                        <Row>
                            <Col lg={{ size: 12, offset: 0 }}>

                                <TextBock addClass="left-center" text={
                                    <Fragment>
                                        <ul>
                                            <li>
                                                traditional loafs, rolls and contemporary sourdough
                                            </li>
                                            <li>
                                                sweets, cakes and biscuits
                                            </li>
                                            <li>
                                                lasagna, moussaka, cannelloni
                                            </li>
                                            <li>
                                                and freshly made sandwiches
                                            </li>
                                        </ul>

                                    </Fragment>
                                } />

                            </Col>
                        </Row>

                        {/*<Row>*/}
                        {/*    <Col lg={{ size: 6, offset: 4 }}>*/}

                        {/*        <TextBock addClass="left-text" text={*/}
                        {/*            <Fragment>*/}
                        {/*                Try our selection of:*/}
                        {/*                <ul>*/}
                        {/*                    <li>*/}
                        {/*                        Traditional loafs,*/}
                        {/*                    </li>*/}
                        {/*                    <li>*/}
                        {/*                        bread rolls and contemporary sourdoughs Sweets,*/}
                        {/*                    </li>*/}
                        {/*                    <li>*/}
                        {/*                        cakes and biscuits,*/}
                        {/*                    </li>*/}
                        {/*                    <li>*/}
                        {/*                        spanakopita and moussaka*/}
                        {/*                    </li>*/}
                        {/*                    <li>*/}
                        {/*                        lasagne and a great range of take home meals Freshly made sandwiches*/}
                        {/*                    </li>*/}
                        {/*                </ul>*/}

                        {/*            </Fragment>*/}
                        {/*        } />*/}

                        {/*    </Col>*/}
                        {/*</Row>*/}

                    </Container>
                </Col>

            </Row>

        </Block>

    );
};

export default AboutUs;
